import React, { FC, useEffect, useState } from 'react'
import { StyledInnerTNInput, StyledTNInput } from './TNInput.styled'
import { IconEditTN, IconEye } from '../../icons'

interface TNInputProps {
    id: string
    label: string
    value?: string
    type?: 'text' | 'password' | 'edit'
    hasError?: boolean
    onChange: (val: string) => void
    onSelect?: () => void
    onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    marginBottom?: number
    autoFocus?: boolean
}
export const TNInput: FC<TNInputProps> = ({
    label,
    id,
    type = 'text',
    value = '',
    hasError = false,
    onChange,
    onSelect,
    onEnter,
    marginBottom,
    autoFocus = false,
}) => {
    const [val, setVal] = useState<string>(value)
    const [inputType, setInputType] = useState<'text' | 'password' | 'edit'>(
        type,
    )
    const [error, setError] = useState<boolean>(hasError)
    const [eyeClose, setEyeClose] = useState<boolean>(false)
    useEffect(() => {
        setVal(value)
        setError(hasError)
    }, [value, hasError, type])

    function onInput(e: React.ChangeEvent<HTMLInputElement>) {
        setVal(e.target.value)
        onChange(e.target.value)
        setError(false)
    }

    function onEyeIconClick() {
        setInputType(inputType === 'password' ? 'text' : 'password')
        setEyeClose(!eyeClose)
    }
    return (
        <StyledTNInput
            isFilled={!!val}
            hasError={error}
            marginBottom={marginBottom}
            hasIcon={type !== 'text'} // We use type not inputType as we want the original value of the input.
        >
            <StyledInnerTNInput hasError={error} isFilled={!!val}>
                <input
                    type={inputType}
                    id={id}
                    value={val}
                    onChange={onInput}
                    onSelect={onSelect}
                    autoFocus={autoFocus}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            onEnter && onEnter(e)
                        }
                    }}
                />
                <label htmlFor={id}>{label}</label>
            </StyledInnerTNInput>
            {type === 'password' && (
                <IconEye
                    eyeClose={eyeClose}
                    onClick={onEyeIconClick}
                    hasError={error}
                />
            )}
            {type === 'edit' && <IconEditTN hasError={error} />}
        </StyledTNInput>
    )
}
